/*
  +--------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Author:    leo<zhudongxian@frippler.com>
  | @Title:     订单管理 API 接口
  | @Version:   2018-12-24  [A] 新建文件
  +--------------------------------------------------------------------------------------
*/
import request from '@/utils/request'

export function getOrderListApi(query) {
  return request({
    url: '?c=expense&a=order&do=list',
    method: 'get',
    params: query
  })
}

export function getOrderDetailApi(orderid) {
  return request({
    url: '?c=expense&a=order&do=get',
    method: 'get',
    params: { orderid }
  })
}

export function cancelOrderApi(params) {
  return request({
    url: '?c=expense&a=order&do=cancel',
    method: 'get',
    params
  })
}

export function enterCashierApi(formData) {
  return request({
    url: '?c=expense&a=cashier&do=enter',
    method: 'post',
    data: formData
  })
}

export function payCashierApi(formData) {
  return request({
    url: '?c=expense&a=cashier&do=pay',
    method: 'post',
    data: formData
  })
}

export function cancelCashierApi(orderid) {
  return request({
    url: '?c=expense&a=cashier&do=cancel',
    method: 'post',
    data: { orderid }
  })
}

export function checkCashierApi(params) {
  return request({
    url: '?c=expense&a=cashier&do=query',
    method: 'get',
    params
  })
}
